import React from 'react';
import { useTranslation } from 'react-i18next';

import SPICE_ICON from '../../images/icons/SpiceIconOrange.svg';
import EPS_ICON from '../../images/icons/ElitePairingStudioIconOrange.svg';
import Link from '../Link';
import { CIDS } from './constants';
import pushToGTM, { redirectToTibosGA4, redirectToElitePairingStudioGA4 } from '../../utils/analytics/gtm';
import { buildSpiceLiveModelUrl, buildElitePairingStudioUrl } from './simulationsLinks';

/**
 * Renders zero, one, or two icon-links in the Simulations cell depending on
 * which boolean flags (`slms`, `epss`) are set on the row.
 *
 * `path` is window.location.pathname, used to distinguish Gate Driver from
 * MOSFET so the Elite Pairing Studio URL is built correctly.
 */
export default function SimulationsCell({ row, path }) {
	const { t } = useTranslation('main');
	const partNumber = row[CIDS.PART_NUMBER];
	const isGateDriver = path.includes('/gate-driver');

	const spiceUrl = row[CIDS.SPICE_LIVE_MODEL_SUPPORTED] ? buildSpiceLiveModelUrl(partNumber) : null;

	const epsUrl = row[CIDS.ELITE_PAIRING_STUDIO_SUPPORTED] ? buildElitePairingStudioUrl(partNumber, isGateDriver) : null;

	if (!spiceUrl && !epsUrl) return null;

	return (
		<div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
			{spiceUrl && (
				<Link
					tooltipTitle={t('components.productsTable.spiceLiveModel.tooltip')}
					href={spiceUrl}
					target="_blank"
					style={{ textDecoration: 'none' }}
					onClick={() => pushToGTM(redirectToTibosGA4())}>
					<img src={SPICE_ICON} alt="SPICE Live Model" style={{ height: '2rem' }} />
				</Link>
			)}
			{epsUrl && (
				<Link
					tooltipTitle={t('components.productsTable.elitePairingStudio.tooltip')}
					href={epsUrl}
					target="_blank"
					style={{ textDecoration: 'none' }}
					onClick={() => pushToGTM(redirectToElitePairingStudioGA4())}>
					<img src={EPS_ICON} alt="EP Studio" style={{ height: '2rem' }} />
				</Link>
			)}
		</div>
	);
}
